<template>
    <div class="modal fade" id="showPartsModal" tabindex="-1" aria-labelledby="showPartsModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="showPartsModalLabel">Show Parts</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div style="display: flex; justify-content: center; align-items: flex-end">
                        <textarea :value="partsTextValue" class="textarea" id="show_parts_text" style="
                            width: 250px;
                            height: 367px;
                            overflow-y: auto;
                            overflow-x: auto;
                            cursor: text;
                            " disabled>
                        </textarea>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="buttons is-right" style="width: 100%">
                        <button class="button" @click="doCopy">
                            <span> Copy </span>
                        </button>
                        <button class="button is-info" data-bs-dismiss="modal" aria-label="Close">OK</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>

<script>
export default {
    name: "ModalShowParts",
    emits: ['doCopy'],
    props: {
        partsTextValue: {
            type: String,
            default: "",
        },
    },
    methods: {
        doCopy() {
            this.$emit("doCopy");
        },
    },
};
</script>
